export interface CameraState {
  mode: "follow" | "tactical" | "magnify";
  targetId?: string;
  transitionProgress: number; // 0→1 lerp
}

export const cameraState: CameraState = {
  mode: "follow",
  transitionProgress: 1,
};

export function setCameraMode(mode: CameraState["mode"], targetId?: string) {
  cameraState.mode = mode;
  cameraState.targetId = targetId;
  cameraState.transitionProgress = 0;
}
